import { Component, HostBinding, Input } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolIconComponent } from '../../core/sol-icon/sol-icon.component';
import { SolIcon } from '@sol/icons';
import { TranslatePipe } from '../../../pipes/translate.pipe';

import { SolValidationMessage } from '../../../models/core/sol-validation-message';
import { SolValidationMessagesState } from './sol-validation-messages.state';

@Component({
  selector: 'sol-validation-messages',
  imports: [SolIconComponent, TranslatePipe],
  templateUrl: './sol-validation-messages.component.html',
})
export class SolValidationMessagesComponent extends AbstractComponent<SolValidationMessagesState> {
  protected readonly SolIcon = SolIcon;

  // Computed
  protected readonly messages$ = this.compute(state => state.visibleMessages);
  protected readonly messageClasses$ = this.compute(state => state.messageClasses);
  protected readonly icons$ = this.compute(state => state.icons);

  constructor() {
    super(SolValidationMessagesState.of());
  }

  @HostBinding('class')
  public get hostClass(): string {
    return 'sol-form-content';
  }

  @Input()
  public set messages(messages: SolValidationMessage[]) {
    this.update(state => state.withMessages(messages));
  }

  @Input()
  public set showAll(showAll: boolean) {
    this.update(state => state.withShowAll(showAll));
  }
}
